import { useState, useEffect, useCallback } from "react";

import API from "utils/api";
import { useUser } from "utils/hooks";

export default function useCaptcha(userId, filters = {}) {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadedOnce, setLoadedOnce] = useState(false);

  const fetchCaptcha = useCallback(async () => {
    setLoading(true);
    const { response, data } = await API.fetchCaptcha();

    if (response.ok) {
      setResult(data);
      setLoadedOnce(true);
      setLoading(false);
    }
  }, [setLoading, setResult]);

  useEffect(() => {
    fetchCaptcha();
  }, [setLoading, setResult]);

  return {
    loading: !loadedOnce && loading,
    refresh: fetchCaptcha,
    captcha: result ?? null,
  };
}
